// bootstrap5 app — extends the base tier's app with Bootstrap 5-conceptual
// behaviour. Pure Bootstrap concepts only (e.g. data-bs-theme handling for
// light/dark mode); leaf-theme integrations like KTComponents.init() or
// KTApp's page-loading spinner stay in the leaf's own app.js.
const baseApp = require('../../base/scripts/app');

const app = Object.assign({}, baseApp, {
    // Theme bootstrap. Sets the data-bs-theme attribute (light/dark) and
    // bridges zit-namespaced markup onto Bootstrap's data-bs-* equivalents
    // across the whole document so Bootstrap's auto-discovery (collapse
    // trigger click handler, Tooltip auto-init, Toast close button) finds
    // the static page markup. Dynamic markup inserted later is bridged
    // per-subtree by base consumers (editList, widgetsList, messages).
    // Tiers extending zb5 (e.g. metronic_8) chain to this method via
    // zb5App.initTheme.call(this) before adding their own boot work.
    initTheme: function () {
        this.initThemeMode();
        // Mirror zit-namespaced markers onto data-bs-* equivalents so
        // Bootstrap's auto-discovery (collapse trigger click handler, Tooltip
        // auto-init, Toast close button) finds the static page markup.
        this.hm.behaviors.bridgeTierAttrs(document);
        // Apply initial collapse-state classes to every [data-zit-collapsible]
        // body wrapper on the page. Must run AFTER bridgeTierAttrs so the
        // mirrored data-bs-toggle="collapse" trigger is already in place when
        // Bootstrap's first click event fires, and BEFORE any user interaction.
        // Inclusive on document — querySelectorAll handles the scan.
        this.hm.behaviors.collapse.createInstances(document);
    },

    // Detect and apply the Bootstrap theme mode (light/dark/system) using
    // Bootstrap 5.3's data-bs-theme contract. Reads (in order of precedence):
    //   1. document.documentElement[data-bs-theme-mode] — explicit caller intent
    //   2. localStorage[data-bs-theme] — persisted user choice
    //   3. defaultThemeMode = "light"
    // 'system' resolves via prefers-color-scheme matchMedia. The result lands
    // on document.documentElement[data-bs-theme] which Bootstrap CSS targets.
    initThemeMode: function () {
        var defaultThemeMode = "light";
        var themeMode;

        if (document.documentElement) {
            if (document.documentElement.hasAttribute("data-bs-theme-mode")) {
                themeMode = document.documentElement.getAttribute("data-bs-theme-mode");
            } else if (localStorage.getItem("data-bs-theme") !== null) {
                themeMode = localStorage.getItem("data-bs-theme");
            } else {
                themeMode = defaultThemeMode;
            }

            if (themeMode === "system") {
                themeMode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            }

            document.documentElement.setAttribute("data-bs-theme", themeMode);
        }
    }
});

module.exports = app;
